import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FormatListBulletedSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FormatListBulletedSVG;
